module.exports = __webpack_public_path__ + "static/media/terms-privacy.0de31867.svg";